export function GenerateEventInfoTimestamp(src: any, dest: any): void {
  dest.event.eventInfo.timeStamp = new Date().toISOString();
}
